import { render } from "./mvt-pagination.vue?vue&type=template&id=4c6d0b3e"
import script from "./mvt-pagination.js?vue&type=script&lang=js"
export * from "./mvt-pagination.js?vue&type=script&lang=js"

import "./mvt-pagination.vue?vue&type=style&index=0&id=4c6d0b3e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__